import { QueryClient } from 'react-query'
import { shouldRetryQuery } from './queryClient.functions'

export { useAdmins } from './admins'
export { useExitPages } from './analytics'
export {
  usePlayerBalances,
  usePlayerOverrideStatus,
  usePlayerOverrideStatusMutation,
} from './balances'
export {
  useBonuses,
  useBonus,
  useNewBonusMutation,
  useUserBonuses,
  usePublishBonusMutation,
  useDeleteBonusMutation,
  useCancelAssignmentMutation,
} from './bonuses'
export {
  useCampaigns,
  useCampaign,
  useCampaignEnabledMutation,
  useNewCampaignMutation,
  useBonusAssignments,
  usePublishCampaignMutation,
  useDeleteCampaignMutation,
  useUpdateCampaignMutation,
} from './campaigns'
export { useCurrencies } from './currencies'
export {
  useTopGames,
  useGames,
  useProviderFreeSpins,
  useGamesProviders,
  useGameTypes,
  useGameSubtypes,
} from './games'
export {
  usePlayer,
  usePlayers,
  usePlayerChangelog,
  usePlayersChangelog,
  usePlayersOnline,
  useStatusDurationMutation,
  useSelfExclusionDurationMutation,
  usePlayersSession,
  usePlayerAnalytics,
  usePlayersStatusMutation,
  usePlayerOnline,
  usePlayersStatus,
  usePlayersStatusId,
  useTotalPlayers,
  useTotalNewPlayers,
  useActivePlayers,
  useActiveTrends,
  useNewTrends,
  useTotalTrends,
  useTotalByCountry,
  useTopByCountry,
  useTotalContinent,
  useTotalNewContinent,
  useStats,
  useUpdatePlayerMutation,
  useNewNotePlayerMutation,
  useNotesPlayer,
  useNotesNetwork,
  useNotePlayer,
  useDeleteNoteMutation,
  useEditNoteMutation,
  usePatchNoteMutation,
  useSelfExclusionInformation,
  useTimeOutInformation,
  useDeleteAttachmentMutation,
  useAddAttachmentMutation,
  useKYCdetails,
  useKYCcheck,
  useAccountSummary,
  usePlayerTags,
  useTags,
  useTagsMutation,
  useDeleteTagsMutation,
  useUpdatePartialPlayerMutation,
  usePlayerVerificationData,
  useProductPreferences,
  useMarketingPreferences,
  useMarketingPreferencesMutation,
  useAllMarketingPreferencesMutation,
  useExemptFromFeesMutation,
  usePlayerGroups,
  usePlayerGroupById,
  useCreatePlayerGroups,
  useAddPlayersToGroup,
  useDeletePlayerGroup,
  useClearStakeStatus,
  useClearStakeLogs,
  useInitiateClearStake,
  useCancelClearStake,
} from './players'
export { useProviders } from './providers'
export { useUserTotalDeposits } from './total-deposits'
export {
  useNewTransactionLimitMutation,
  useTransactionLimit,
  useEditTransactionLimitMutation,
  useEditTransactionLimitByPeriodMutation,
  useNewTransactionLimitByPeriodMutation,
  useDeleteTransactionLimitMutation,
} from './transaction-limit'
export {
  useAddBonusTransactionMutation,
  useAddBulkManualTransactionMutation,
  useUserTransactions,
  useTransactions,
  useTransactionsTypes,
  useTopPlayers,
  useAdjustmentCategories,
} from './transactions'

export {
  useLifetimeDepositLimit,
  useNewLifetimeDepositLimit,
  useAffordabilityDepositLimit,
  useNewAffordabilityDepositLimit,
} from './affordability'

export {
  useWagersContributionToCashBonus,
  useWagersContributionToCashBonusMutation,
} from './wagers'
export {
  useDepositLimitCaps,
  useNewDepositLimitCapByPeriodMutation,
  useEditDepositLimitCapByPeriodMutation,
  useDeleteDepositLimitCapByPeriodMutation,
} from './deposit-limit-cap'

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: { refetchOnWindowFocus: false, retry: shouldRetryQuery },
  },
})

export * from './network'

export {
  usePaymentCharges,
  usePaymentCharge,
  useCreatePaymentChargeMutation,
  useUpdatePaymentChargeMutation,
  useToggleFeeConfigStateMutation,
  usePaymentProviders,
} from './payment-charges'

export {
  usePaymentMethodsQuery,
  usePaymentMethodQuery,
  useSiteConfigsQuery,
  useCreatePaymentMethodMutation,
  useUpdatePaymentMethodMutation,
  useTogglePaymentMethodEnabledMutation,
  useDeletePaymentMethodMutation,
  useUpdateSiteConfigMutation,
  useDeleteSiteConfigMutation,
} from './payment-methods'

export { useDepositEligibility } from './deposit-eligibility'
